(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('back-to-top')) {
    class BackToTop extends HTMLElement {
      connectedCallback() {
        const sentinel = this.querySelector('[data-back-to-top-sentinel]');
        this.button = this.querySelector('[data-back-to-top-button]');
        if (!sentinel || !this.button) return;

        this.observer = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-visible', !entry.isIntersecting);
        });
        this.observer.observe(sentinel);

        this.onClick = this.onClick.bind(this);
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        event.preventDefault();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });

        // Move keyboard focus to the start of the page, otherwise the next Tab would
        // continue from the (now hidden) button at the bottom.
        // Skip elements hidden at the current breakpoint (e.g. desktop nav on mobile).
        const firstFocusable = [
          ...document.querySelectorAll('.shopify-section-group-header-group :is(a[href], button:not([disabled]))'),
        ].find((element) => element.checkVisibility({ visibilityProperty: true }));
        firstFocusable?.focus({ preventScroll: true });
      }
    }

    customElements.define('back-to-top', BackToTop);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const dialog = document.getElementById('cart-drawer-dialog');
    if (!dialog) return;

    const closeBtn = dialog.querySelector('.cart-drawer__close');
    const continueBtn = dialog.querySelector('.js-continue-shopping');

    // Close handlers
    const closeDrawer = () => {
      dialog.close();
    };

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (continueBtn) continueBtn.addEventListener('click', closeDrawer);

    dialog.addEventListener('close', () => {
      // Clear drag overrides
      dialog.style.transform = '';
      dialog.style.transition = '';
      dialog.style.removeProperty('--swipe-backdrop-opacity');
    });

    // Close when clicking backdrop
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        closeDrawer();
      }
    });

    // --- Dynamic Delivery Date ---
    const updateDeliveryDate = () => {
      const el = dialog.querySelector('.js-cart-delivery-date');
      if (!el) return;

      const minDays = parseInt(el.dataset.minDays || '2', 10);
      const maxDays = parseInt(el.dataset.maxDays || '5', 10);

      const addWorkdays = (startDate, numDays) => {
        let date = new Date(startDate);
        let added = 0;
        while (added < numDays) {
          date.setDate(date.getDate() + 1);
          const day = date.getDay();
          const isWeekend = (day === 0 || day === 6);
          if (!isWeekend && !isGermanHoliday(date)) {
            added++;
          }
        }
        return date;
      };

      const isGermanHoliday = (date) => {
        const m = date.getMonth();
        const d = date.getDate();
        if (m === 0 && d === 1) return true;
        if (m === 4 && d === 1) return true;
        if (m === 9 && d === 3) return true;
        if (m === 11 && d === 25) return true;
        if (m === 11 && d === 26) return true;

        const y = date.getFullYear();
        const easter = getEasterSunday(y);
        const timeDiff = date.getTime() - easter.getTime();
        const daysDiff = Math.round(timeDiff / (1000 * 60 * 60 * 24));
        if (daysDiff === -2) return true;
        if (daysDiff === 1) return true;
        if (daysDiff === 39) return true;
        if (daysDiff === 50) return true;
        return false;
      };

      const getEasterSunday = (year) => {
        const f = Math.floor,
              G = year % 19,
              C = f(year / 100),
              H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
              I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
              J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
              L = I - J,
              month = 3 + f((L + 40) / 44),
              day = L + 28 - 31 * f(month / 4);
        return new Date(Date.UTC(year, month - 1, day));
      };

      const formatDate = (date) => {
        const weekdays = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
        const deMonths = [
          'Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 
          'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'
        ];
        return `${weekdays[date.getDay()]} ${date.getDate()}. ${deMonths[date.getMonth()]}`;
      };

      const today = new Date();
      const minDate = addWorkdays(today, minDays);
      const maxDate = addWorkdays(today, maxDays);

      const templateText = el.textContent;
      const placeholder = '...';
      const formattedRange = `${formatDate(minDate)} - ${formatDate(maxDate)}`;
      
      if (templateText.includes(placeholder)) {
        el.innerHTML = templateText.replace(placeholder, formattedRange);
      } else {
        const prefix = templateText.split(':')[0] || 'Lieferung ca.';
        el.innerHTML = `${prefix}: ${formattedRange}`;
      }
    };

    updateDeliveryDate();

    // --- Touch Swipe-to-close handling for right-side drawer ---
    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let isSwiping = false;

    dialog.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchCurrentX = touchStartX;
      isSwiping = false;
      dialog.style.transition = 'none';
    }, { passive: true });

    dialog.addEventListener('touchmove', (e) => {
      if (e.touches.length !== 1) return;
      touchCurrentX = e.touches[0].clientX;
      
      const diffX = touchCurrentX - touchStartX;
      const diffY = e.touches[0].clientY - touchStartY;
      
      if (!isSwiping) {
        if (diffX > 10 && diffX > Math.abs(diffY)) {
          isSwiping = true;
        }
      }
      
      if (isSwiping && diffX > 0) {
        dialog.style.transform = `translateX(${diffX}px)`;
        const drawerWidth = dialog.offsetWidth || 550;
        const ratio = Math.max(0, 1 - diffX / drawerWidth);
        dialog.style.setProperty('--swipe-backdrop-opacity', ratio);
      }
    }, { passive: true });

    dialog.addEventListener('touchend', () => {
      dialog.style.transition = '';
      dialog.style.removeProperty('--swipe-backdrop-opacity');
      
      if (isSwiping) {
        const diffX = touchCurrentX - touchStartX;
        const threshold = 100;
        
        if (diffX > threshold) {
          closeDrawer();
        } else {
          dialog.style.transform = '';
        }
      }
      isSwiping = false;
    });

    // --- AJAX Remove ---
    const initRemoveListeners = () => {
      const removeButtons = dialog.querySelectorAll('.js-remove-item');
      removeButtons.forEach(btn => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          const itemKey = btn.getAttribute('data-item-key');
          if (!itemKey) return;

          btn.disabled = true;
          btn.style.opacity = '0.5';

          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: itemKey,
              quantity: 0
            })
          })
          .then(res => {
            if (!res.ok) throw new Error('Failed to remove item');
            return res.json();
          })
          .then(cartData => {
            window.refreshCartDrawerAndHeader();
          })
          .catch(err => {
            console.error('Error removing cart item:', err);
            btn.disabled = false;
            btn.style.opacity = '';
          });
        });
      });
    };

    // --- AJAX Clear All Sold Items ---
    const initClearSoldListeners = () => {
      const clearBtn = dialog.querySelector('.js-clear-sold-cart');
      if (!clearBtn) return;
      clearBtn.addEventListener('click', (event) => {
        event.preventDefault();
        const soldItems = dialog.querySelectorAll('.cart-item.is-sold-out');
        const updates = {};
        soldItems.forEach(item => {
          const key = item.getAttribute('data-line-item-key');
          if (key) updates[key] = 0;
        });

        if (Object.keys(updates).length === 0) return;

        clearBtn.disabled = true;
        clearBtn.style.opacity = '0.5';

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(res => {
          if (!res.ok) throw new Error('Failed to remove sold items');
          return res.json();
        })
        .then(() => {
          window.refreshCartDrawerAndHeader();
        })
        .catch(err => {
          console.error('Error clearing sold items:', err);
          clearBtn.disabled = false;
          clearBtn.style.opacity = '';
        });
      });
    };

    // Sections live in groups/JSON templates, so their IDs are generated
    // (e.g. "sections--123__header"). Read them from the DOM; requesting the
    // bare file name would render the section with default settings.
    const sectionIdOf = (el, fallback) =>
      el?.closest('.shopify-section')?.id.replace('shopify-section-', '') || fallback;

    window.refreshCartDrawerAndHeader = () => {
      const wasOpen = dialog.open;
      const headerSectionId = sectionIdOf(document.querySelector('header'), 'header');

      fetch(`/?sections=${headerSectionId}`)
      .then(res => res.json())
      .then(sectionsData => {
        const headerHTML = sectionsData[headerSectionId];
        if (!headerHTML) return;

        const parser = new DOMParser();
        const doc = parser.parseFromString(headerHTML, 'text/html');
        
        // Only update the cart count: replacing the whole header would drop the event
        // listeners of search, menu and the wishlist count
        const newCount = doc.querySelector('.js-cart-count');
        const oldCount = document.querySelector('.js-cart-count');
        if (newCount && oldCount) {
          const previous = parseInt(oldCount.textContent, 10) || 0;
          const current = parseInt(newCount.textContent, 10) || 0;
          oldCount.textContent = current;
          oldCount.style.display = current > 0 ? '' : 'none';
          if (current > previous) window.bumpHeaderCount?.(oldCount);
        }

        const newDialog = doc.querySelector('#cart-drawer-dialog');
        const oldDialog = document.getElementById('cart-drawer-dialog');
        if (newDialog && oldDialog) {
          oldDialog.innerHTML = newDialog.innerHTML;
          
          if (wasOpen) {
            const reOpenedDialog = document.getElementById('cart-drawer-dialog');
            reOpenedDialog.showModal();
          }
        }
        
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(err => {
        console.error('Error refreshing cart drawer:', err);
      });
    };

    // --- Checkout Form validation ---
    const initCheckoutValidation = () => {
      const checkoutForm = dialog.querySelector('.cart-drawer__checkout-form');
      if (!checkoutForm) return;

      checkoutForm.addEventListener('submit', (event) => {
        if (checkoutForm.dataset.validated === 'true') {
          return; // Let form submit normally
        }

        event.preventDefault();
        const checkoutBtn = checkoutForm.querySelector('.cart-drawer__checkout-btn');
        if (!checkoutBtn || checkoutBtn.disabled) return;

        // Set button loading state
        checkoutBtn.disabled = true;
        checkoutBtn.setAttribute('aria-disabled', 'true');
        const loadingText = checkoutBtn.dataset.loadingText || 'Verfügbarkeit wird geprüft...';
        checkoutBtn.innerHTML = `<svg class="cart-btn-spinner" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg> <span>${loadingText}</span>`;

        // Fetch fresh header HTML to check availability
        const headerSectionId = sectionIdOf(document.querySelector('header'), 'header');
        fetch(`/?sections=${headerSectionId}`)
          .then(res => {
            if (!res.ok) throw new Error('Fetch failed');
            return res.json();
          })
          .then(sectionsData => {
            const headerHTML = sectionsData[headerSectionId];
            if (!headerHTML) throw new Error('No header markup returned');

            const parser = new DOMParser();
            const doc = parser.parseFromString(headerHTML, 'text/html');
            
            // Check if there are any sold out items in the fresh HTML
            const hasSoldOut = doc.querySelector('.cart-item.is-sold-out') !== null;

            if (hasSoldOut) {
              // Update drawer/header with the new HTML to show the sold-out warnings and disable the button
              const newDialog = doc.querySelector('#cart-drawer-dialog');
              const oldDialog = document.getElementById('cart-drawer-dialog');
              if (newDialog && oldDialog) {
                const wasOpen = oldDialog.open;
                oldDialog.innerHTML = newDialog.innerHTML;
                if (wasOpen) {
                  const reOpenedDialog = document.getElementById('cart-drawer-dialog');
                  reOpenedDialog.showModal();
                }
              }

              const newHeader = doc.querySelector('header');
              const oldHeader = document.querySelector('header');
              if (newHeader && oldHeader) {
                oldHeader.innerHTML = newHeader.innerHTML;
              }

              document.dispatchEvent(new CustomEvent('cart:updated'));
            } else {
              // Validation passed, submit form to proceed to checkout
              checkoutForm.dataset.validated = 'true';
              checkoutForm.submit();
            }
          })
          .catch(err => {
            console.error('Error verifying cart availability before checkout:', err);
            // Fallback: Proceed to checkout if network fails (Shopify will validate it anyway)
            checkoutForm.dataset.validated = 'true';
            checkoutForm.submit();
          });
      });
    };

    document.addEventListener('cart:updated', () => {
      initRemoveListeners();
      initClearSoldListeners();
      updateDeliveryDate();
      initCheckoutValidation();
      
      const newCloseBtn = dialog.querySelector('.cart-drawer__close');
      const newContinueBtn = dialog.querySelector('.js-continue-shopping');
      if (newCloseBtn) newCloseBtn.addEventListener('click', closeDrawer);
      if (newContinueBtn) newContinueBtn.addEventListener('click', closeDrawer);
    });

    initRemoveListeners();
    initClearSoldListeners();
    initCheckoutValidation();

    // Reset checkout button loading state on pageshow (e.g., back button from checkout)
    window.addEventListener('pageshow', (event) => {
      const checkoutForm = dialog.querySelector('.cart-drawer__checkout-form');
      const checkoutBtn = dialog.querySelector('.cart-drawer__checkout-btn');
      if (checkoutForm && checkoutBtn) {
        checkoutForm.removeAttribute('data-validated');
        
        // Only reset if it is currently in loading state
        if (checkoutBtn.disabled && checkoutBtn.getAttribute('aria-disabled') === 'true' && checkoutBtn.querySelector('.cart-btn-spinner')) {
          checkoutBtn.disabled = false;
          checkoutBtn.removeAttribute('aria-disabled');
          if (checkoutBtn.dataset.originalText) {
            checkoutBtn.innerHTML = checkoutBtn.dataset.originalText;
          }
        }
      }

      // If loaded from back/forward cache, refresh cart data to be absolutely sure of stock levels
      if (event.persisted && typeof window.refreshCartDrawerAndHeader === 'function') {
        window.refreshCartDrawerAndHeader();
      }
    });

    // Refresh cart drawer when tab becomes visible if drawer is open
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        if (dialog && dialog.open && typeof window.refreshCartDrawerAndHeader === 'function') {
          window.refreshCartDrawerAndHeader();
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["infinite-scroll"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('infinite-scroll')) {
    class InfiniteScroll extends HTMLElement {
      connectedCallback() {
        this.list = document.getElementById(this.dataset.target);
        this.nextUrl = this.dataset.nextUrl;
        this.loadingEl = this.querySelector('[data-infinite-loading]');
        this.moreLink = this.querySelector('[data-infinite-more]');
        this.statusEl = this.querySelector('[data-infinite-status]');
        this.pagination = this.querySelector('[data-infinite-pagination]');
        if (!this.list || !this.nextUrl) return;

        // Start loading well before the end so the list keeps flowing while scrolling
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadNext();
        }, { rootMargin: '0px 0px 800px 0px' });
        this.observer.observe(this);

        this.moreLink?.addEventListener('click', (event) => {
          event.preventDefault();
          this.moreLink.hidden = true;
          this.loadNext();
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      async loadNext() {
        if (this.isLoading || !this.nextUrl) return;
        this.isLoading = true;
        this.loadingEl.hidden = false;
        this.list.setAttribute('aria-busy', 'true');

        try {
          const url = new URL(this.nextUrl, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url);
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

          const nextList = doc.getElementById(this.dataset.target);
          const items = nextList ? [...nextList.children] : [];
          this.list.append(...items);

          // The loaded page only carries a next URL while it is still inside the current group
          const nextLoader = doc.querySelector(`infinite-scroll[data-target="${this.dataset.target}"]`);
          this.nextUrl = nextLoader?.dataset.nextUrl || '';
          if (this.moreLink && this.nextUrl) this.moreLink.href = this.nextUrl;

          this.statusEl.textContent = (this.dataset.loadedLabel || '').replace('[count]', items.length);
          // Let product cards bind wishlist/cart/similar handlers to the new markup
          document.dispatchEvent(new CustomEvent('product-cards:added'));

          if (!this.nextUrl) {
            this.observer.disconnect();
            if (this.pagination) this.pagination.hidden = false;
          } else {
            // Re-check: if the end of the list is still in view, load the following page too
            this.observer.unobserve(this);
            this.observer.observe(this);
          }
        } catch (error) {
          console.error('Error loading more products:', error);
          // Fall back to a manual button instead of retrying endlessly
          this.observer.disconnect();
          if (this.moreLink) this.moreLink.hidden = false;
        } finally {
          this.isLoading = false;
          this.loadingEl.hidden = true;
          this.list.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('infinite-scroll', InfiniteScroll);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["media-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('media-slider')) {
    customElements.define(
      'media-slider',
      class MediaSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.media-slider__track');
          this.count = this.querySelector('.media-slider__count');
          this.buttons = [...this.querySelectorAll('.media-slider__btn')];
          if (!this.track || !this.count) return;

          this.update = this.update.bind(this);
          this.buttons.forEach((button) =>
            button.addEventListener('click', () => {
              this.track.scrollBy({ left: this.track.clientWidth * Number(button.dataset.dir) });
            })
          );
          this.track.addEventListener('scroll', this.update, { passive: true });
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        // Zählt Seiten statt Bilder: bei der Reihe sind mehrere Bilder pro Seite sichtbar
        update() {
          const { scrollLeft, scrollWidth, clientWidth } = this.track;
          const width = clientWidth || 1;
          const pages = Math.max(1, Math.round(scrollWidth / width));
          const atEnd = scrollLeft + width >= scrollWidth - 2;
          const page = atEnd ? pages - 1 : Math.round(scrollLeft / width);
          this.count.textContent = `${page + 1} / ${pages}`;
          this.buttons[0].disabled = page === 0;
          this.buttons[1].disabled = page === pages - 1;
          this.querySelector('.media-slider__nav').hidden = pages < 2;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    // --- Wishlist active states (idempotent, also runs for injected cards) ---
    const initializeWishlistStates = (root = document) => {
      try {
        const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
        if (Array.isArray(wishlist)) {
          root.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
            const handle = btn.getAttribute('data-wishlist-toggle');
            const isActive = wishlist.includes(handle);
            btn.classList.toggle('is-active', isActive);
            btn.setAttribute('aria-pressed', String(isActive));
          });
        }
      } catch (e) {
        console.error('Error reading wishlist on load:', e);
      }
    };

    // --- AJAX cart state sync ---
    const syncCartButtons = () => {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const cartVariantIds = cart.items.map(item => item.variant_id);
          document.querySelectorAll('[data-cart-add]').forEach(btn => {
            const variantId = parseInt(btn.getAttribute('data-cart-add'), 10);
            const isInCart = cartVariantIds.includes(variantId);
            btn.classList.toggle('is-success', isInCart);
            btn.style.pointerEvents = '';
            btn.style.opacity = '';

            const labelAdd = btn.getAttribute('data-label-add');
            const labelRemove = btn.getAttribute('data-label-remove');
            if (isInCart && labelRemove) {
              btn.setAttribute('aria-label', labelRemove);
            } else if (!isInCart && labelAdd) {
              btn.setAttribute('aria-label', labelAdd);
            }
          });
        })
        .catch(err => console.error('Error syncing cart buttons:', err));
    };

    // --- Listener binding, guarded per element so re-runs only bind new cards ---
    const bindCardInteractions = (root = document) => {
      // Handle heart button toggle clicks
      root.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
        if (btn.dataset.jsBound) return;
        btn.dataset.jsBound = 'true';
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const handle = btn.getAttribute('data-wishlist-toggle');
          if (!handle) return;

          try {
            let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
            if (!Array.isArray(wishlist)) wishlist = [];

            if (wishlist.includes(handle)) {
              wishlist = wishlist.filter(item => item !== handle);
              btn.classList.remove('is-active');
              btn.setAttribute('aria-pressed', 'false');
            } else {
              wishlist.push(handle);
              btn.dataset.animate = '';
              btn.classList.add('is-active');
              btn.setAttribute('aria-pressed', 'true');
            }

            localStorage.setItem('wishlist', JSON.stringify(wishlist));

            // Dispatch custom event to notify header wishlist count badge
            document.dispatchEvent(new CustomEvent('wishlist:updated'));
          } catch (e) {
            console.error('Error toggling wishlist:', e);
          }
        });
      });

      // AJAX toggle cart (add if absent, remove if present)
      root.querySelectorAll('[data-cart-add]').forEach(btn => {
        if (btn.dataset.jsBound) return;
        btn.dataset.jsBound = 'true';
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const variantId = btn.getAttribute('data-cart-add');
          if (!variantId) return;

          const isRemoving = btn.classList.contains('is-success');

          // Visual loading state
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.7';

          const endpoint = isRemoving ? '/cart/change.js' : '/cart/add.js';
          const payload = isRemoving
            ? { id: variantId, quantity: 0 }
            : { items: [{ id: variantId, quantity: 1 }] };

          fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          })
          .then(response => {
            if (!response.ok) {
              throw new Error('Network error');
            }
            return response.json();
          })
          .then(data => {
            btn.classList.toggle('is-success', !isRemoving);
            btn.style.pointerEvents = '';
            btn.style.opacity = '';

            if (isRemoving) {
              delete btn.dataset.justAdded;
            } else {
              btn.dataset.justAdded = '';
              btn.closest('.collection-product__image-container')?.addEventListener(
                'pointerleave',
                () => delete btn.dataset.justAdded,
                { once: true }
              );
            }

            const labelAdd = btn.getAttribute('data-label-add');
            const labelRemove = btn.getAttribute('data-label-remove');
            if (!isRemoving && labelRemove) {
              btn.setAttribute('aria-label', labelRemove);
            } else if (isRemoving && labelAdd) {
              btn.setAttribute('aria-label', labelAdd);
            }

            // Refresh the header cart count and drawer
            if (typeof window.refreshCartDrawerAndHeader === 'function') {
              window.refreshCartDrawerAndHeader();
            } else {
              document.dispatchEvent(new CustomEvent('cart:updated'));
            }
          })
          .catch(error => {
            console.error(isRemoving ? 'Error removing from cart:' : 'Error adding to cart:', error);
            btn.style.pointerEvents = '';
            btn.style.opacity = '';
          });
        });
      });

      // Swipe handoff: at the last (or first) image, a swipe further outward moves the
      // surrounding horizontal carousel by one card. Browsers that chain the scroll natively
      // move it themselves; the passive listeners only step in when the carousel stayed put
      // (Safari lets the image slider bounce instead).
      function bindSwipeHandoff(slider, productCard) {
        let start = null;

        const findOuterScroller = () => {
          for (let el = productCard.parentElement; el && el !== document.body; el = el.parentElement) {
            const overflowX = getComputedStyle(el).overflowX;
            if ((overflowX === 'auto' || overflowX === 'scroll') && el.scrollWidth > el.clientWidth) return el;
          }
          return null;
        };

        slider.addEventListener('touchstart', (event) => {
          const outer = findOuterScroller();
          if (!outer || event.touches.length !== 1) {
            start = null;
            return;
          }
          const maxScroll = slider.scrollWidth - slider.clientWidth;
          start = {
            x: event.touches[0].clientX,
            y: event.touches[0].clientY,
            outer,
            outerScroll: outer.scrollLeft,
            atStart: slider.scrollLeft <= 2,
            atEnd: slider.scrollLeft >= maxScroll - 2
          };
        }, { passive: true });

        slider.addEventListener('touchend', (event) => {
          if (!start) return;
          const { x, y, outer, outerScroll, atStart, atEnd } = start;
          start = null;

          const touch = event.changedTouches[0];
          const dx = touch.clientX - x;
          const dy = touch.clientY - y;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          if (Math.abs(outer.scrollLeft - outerScroll) > 2) return;

          const direction = dx < 0 ? 1 : -1;
          if ((direction === 1 && !atEnd) || (direction === -1 && !atStart)) return;

          const gap = parseFloat(getComputedStyle(outer).columnGap) || 0;
          outer.scrollBy({ left: direction * (productCard.offsetWidth + gap) });
        }, { passive: true });
      }

      // Hydrate deferred secondary images only on user intent (hover, touch, focus, or swipe)
      const hydrateCardImages = (container, onlySecond = false) => {
        const selector = onlySecond
          ? 'img[data-src][data-image-index="1"]'
          : 'img[data-src]';
        container.querySelectorAll(selector).forEach((img) => {
          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
            delete img.dataset.srcset;
          }
          if (img.dataset.src) {
            img.src = img.dataset.src;
            delete img.dataset.src;
          }
        });
      };

      // Mobile image slider bars update
      root.querySelectorAll('.collection-product__image-slider').forEach(slider => {
        if (slider.dataset.jsBound) return;
        slider.dataset.jsBound = 'true';

        const productCard = slider.closest('.collection-product');
        if (!productCard) return;

        const imgContainer = productCard.querySelector('.collection-product__image-container');
        if (imgContainer) {
          imgContainer.addEventListener('pointerenter', () => hydrateCardImages(slider, true), { once: true, passive: true });
          imgContainer.addEventListener('focusin', () => hydrateCardImages(slider, true), { once: true, passive: true });
        }
        slider.addEventListener('touchstart', () => hydrateCardImages(slider, false), { once: true, passive: true });
        slider.addEventListener('scroll', () => hydrateCardImages(slider, false), { once: true, passive: true });

        bindSwipeHandoff(slider, productCard);

        const bars = productCard.querySelectorAll('.collection-product__indicator-bar');
        if (bars.length === 0) return;

        slider.addEventListener('scroll', () => {
          const width = slider.clientWidth;
          if (width === 0) return;
          const scrollLeft = slider.scrollLeft;
          const activeIndex = Math.round(scrollLeft / width);

          bars.forEach((bar, idx) => {
            if (idx === activeIndex) {
              bar.classList.add('is-active');
            } else {
              bar.classList.remove('is-active');
            }
          });
        }, { passive: true });
      });
    };

    bindCardInteractions();
    initializeWishlistStates();

    // Listen to cart:updated custom event to sync buttons (e.g. on item remove)
    document.addEventListener('cart:updated', syncCartButtons);

    // Sync cart buttons when restored from back-forward cache (initial server render already matches cart.items)
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) syncCartButtons();
    });

    // Cards injected after page load (e.g. wishlist page) announce themselves here
    document.addEventListener('product-cards:added', () => {
      bindCardInteractions();
      initializeWishlistStates();
      syncCartButtons();
    });
  });

  // Page transition: the image of the clicked card morphs into the product page image
  // (cross-document view transition, enabled in assets/critical.css). The name is set
  // only on the clicked card right before leaving, because names must be unique.
  if (!window.productCardTransitionBound) {
    window.productCardTransitionBound = true;
    let clickedCard = null;

    document.addEventListener('click', (event) => {
      const plainClick = !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
      const link = plainClick ? event.target.closest('.collection-product a[href*="/products/"]') : null;
      clickedCard = link ? link.closest('.collection-product') : null;
    });

    const clearTransitionNames = () => {
      document.querySelectorAll('[data-transition-named]').forEach((element) => {
        element.style.viewTransitionName = '';
        delete element.dataset.transitionNamed;
      });
    };

    const setTransitionName = (element, name) => {
      element.style.viewTransitionName = name;
      element.dataset.transitionNamed = '';
    };

    window.addEventListener('pageswap', (event) => {
      if (!event.viewTransition || !clickedCard) return;
      const image = clickedCard.querySelector('.collection-product__image--primary');
      clickedCard = null;
      if (!image) return;

      clearTransitionNames();
      // On a product page its own gallery image carries the name already
      document.querySelectorAll('.product-gallery__main-image').forEach((galleryImage) => {
        setTransitionName(galleryImage, 'none');
      });
      setTransitionName(image, 'product-image');
    });

    // Back navigation restores this page from the cache with the name still set, so the
    // image morphs back into its card; remove the name afterwards
    window.addEventListener('pagereveal', async (event) => {
      if (event.viewTransition) {
        await event.viewTransition.finished.catch(() => {});
      }
      clearTransitionNames();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["similar-items-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('similar-items-drawer')) {
    class SimilarItemsDrawer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.content = this.querySelector('[data-similar-content]');
        this.loading = this.querySelector('[data-similar-loading]');
        this.error = this.querySelector('[data-similar-error]');
        this.cache = new Map();

        this.onDocumentClick = this.onDocumentClick.bind(this);
        document.addEventListener('click', this.onDocumentClick);

        this.querySelector('[data-similar-close]').addEventListener('click', () => this.dialog.close());
        // Close when clicking the backdrop (the dialog element itself)
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        // Return focus to the link that opened the drawer (not every browser focuses links on click)
        this.dialog.addEventListener('close', () => {
          if (this.trigger?.isConnected) this.trigger.focus();
        });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      onDocumentClick(event) {
        const trigger = event.target.closest('[data-similar-items]');
        if (!trigger) return;
        // Let modified clicks (new tab etc.) follow the category link
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.trigger = trigger;
        this.open(trigger.dataset.similarItems);
      }

      open(productUrl) {
        if (!productUrl) return;
        if (!this.dialog.open) this.dialog.showModal();
        this.load(productUrl);
      }

      async load(productUrl) {
        const url = `${productUrl.split('?')[0]}?section_id=similar-items`;
        this.error.hidden = true;

        if (this.cache.has(url)) {
          this.render(this.cache.get(url));
          return;
        }

        this.content.replaceChildren();
        this.loading.hidden = false;
        this.dialog.setAttribute('aria-busy', 'true');
        this.currentUrl = url;

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const markup = doc.querySelector('.similar-items')?.outerHTML || '';
          this.cache.set(url, markup);
          // Ignore responses for a product the user has already moved away from
          if (this.currentUrl === url) this.render(markup);
        } catch (err) {
          console.error('Error loading similar items:', err);
          this.error.hidden = false;
        } finally {
          this.loading.hidden = true;
          this.dialog.removeAttribute('aria-busy');
        }
      }

      render(markup) {
        this.content.innerHTML = markup;
        this.querySelector('.similar-drawer__body').scrollTop = 0;
        // Bind wishlist/cart handlers of the product cards inside the drawer
        document.dispatchEvent(new CustomEvent('product-cards:added'));
      }
    }

    customElements.define('similar-items-drawer', SimilarItemsDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('store-status')) {
    customElements.define(
      'store-status',
      class StoreStatus extends HTMLElement {
        connectedCallback() {
          let hours;
          try {
            hours = JSON.parse(this.dataset.hours);
          } catch {
            return;
          }
          if (!Array.isArray(hours) || hours.length !== 7) return;

          // Aktuelle Zeit in Ulm, unabhängig von der Zeitzone des Geräts
          const parts = Object.fromEntries(
            new Intl.DateTimeFormat('en-GB', {
              timeZone: 'Europe/Berlin',
              weekday: 'short',
              hour: '2-digit',
              minute: '2-digit',
              hourCycle: 'h23',
            })
              .formatToParts(new Date())
              .map((part) => [part.type, part.value])
          );
          const today = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(parts.weekday);
          const now = Number(parts.hour) * 60 + Number(parts.minute);
          const toMinutes = (time) => {
            const [h, m] = String(time).split(':').map(Number);
            return h * 60 + (m || 0);
          };
          const days = this.dataset.days.split(',');
          // Platzhalter %time% / %day% aus den Übersetzungen ersetzen
          const fill = (template, values) => template.replace(/%(\w+)%/g, (_, key) => values[key] ?? '');

          const slots = hours[today] || [];
          const open = slots.find(([from, to]) => now >= toMinutes(from) && now < toMinutes(to));
          let text;

          if (open) {
            text = fill(this.dataset.open, { time: open[1] });
            this.classList.add('store-status--open');
          } else {
            const later = slots.find(([from]) => toMinutes(from) > now);
            if (later) {
              text = fill(this.dataset.opensToday, { time: later[0] });
            } else {
              for (let offset = 1; offset <= 7; offset++) {
                const index = (today + offset) % 7;
                if (hours[index]?.length) {
                  const template = offset === 1 ? this.dataset.opensTomorrow : this.dataset.opensDay;
                  text = fill(template, { time: hours[index][0][0], day: days[index] });
                  break;
                }
              }
            }
          }

          if (!text) return;
          this.textContent = text;
          this.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
